<script>
  // GuaSummary: it got called from Qi (AutoQi & HandQi) and Gua64 (for books and play)
  export let numStr
  export let question
  export let sectionName
  export let isLogin
  // export let gotCalledFrom

  // console.log("@GuaSummary: got called from " + sectionName)

  //import { zhouyi } from "../etc/zhouyi.js"
  //import AesCtr from "../etc/aes-ctr.js"
  import GuaResult from "./GuaResult.svelte"
  import ShowGuaPic from "./ShowGuaPic.svelte"
  import ShowGuaText from "./ShowGuaText.svelte"
  import ShowYaoText from "./ShowYaoText.svelte"
  import ShowCompleteYaoInfo from "./ShowCompleteYaoInfo.svelte"
  import YangYao from "./YangYao.svelte"
  import YinYao from "./YinYao.svelte"

  import { selectedLanguage } from "../etc/store.js"
  import {
    buildYaoColorArray,
    number2code,
    findGua,
    getGuaText,
    btn_style_yellow_d2,
    btn_style_blue_d2,
    btn_style_light_blue_a3,
    btn_style_orange_d2,
    btn_style_teal,
    btn_style_purple_d2,
    btn_style_green_l2,
    xiyiSalt,
  } from "../etc/helpers.js"

  $: gua_code = number2code(numStr)

  $: guaName = findGua(gua_code, $selectedLanguage)

  let yaoColor = buildYaoColorArray(numStr)
  let guaText = {}
  let yao1 = ""
  let yao2 = ""
  let yao3 = ""
  let yao4 = ""
  let yao5 = ""
  let yao6 = ""
  let yaoXiang1 = ""
  let yaoXiang2 = ""
  let yaoXiang3 = ""
  let yaoXiang4 = ""
  let yaoXiang5 = ""
  let yaoXiang6 = ""
  let yaoPic1 = true
  let yaoPic2 = true
  let yaoPic3 = true
  let yaoPic4 = true
  let yaoPic5 = true
  let yaoPic6 = true

  $: if (gua_code != null) {
    guaText = getGuaText(gua_code, $selectedLanguage)
    gua_code[0] == 1 ? (yaoPic1 = true) : (yaoPic1 = false)
    gua_code[1] == 1 ? (yaoPic2 = true) : (yaoPic2 = false)
    gua_code[2] == 1 ? (yaoPic3 = true) : (yaoPic3 = false)
    gua_code[3] == 1 ? (yaoPic4 = true) : (yaoPic4 = false)
    gua_code[4] == 1 ? (yaoPic5 = true) : (yaoPic5 = false)
    gua_code[5] == 1 ? (yaoPic6 = true) : (yaoPic6 = false)
  }

  $: if (guaText != null) {
    yao1 = guaText.yao1
    yao2 = guaText.yao2
    yao3 = guaText.yao3
    yao4 = guaText.yao4
    yao5 = guaText.yao5
    yao6 = guaText.yao6

    yaoXiang1 = guaText.yaoXiang1
    yaoXiang2 = guaText.yaoXiang2
    yaoXiang3 = guaText.yaoXiang3
    yaoXiang4 = guaText.yaoXiang4
    yaoXiang5 = guaText.yaoXiang5
    yaoXiang6 = guaText.yaoXiang6
  }
  //   $: console.log("@ GuaSummary - guaText is below...")
  //   $: console.log(guaText)

  //   $: if (guaText != null) {
  //     console.log(guaText.fullName)
  //   }

  let showSummary = true
  let showDetails = false
  //let// showWholeView = false

  function getParameterByName(name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[\[\]]/g, "\\$&")
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ""
    return decodeURIComponent(results[2].replace(/\+/g, " "))
  }

  //numStr = getParameterByName("gs")

  // console.log("@ GuaSummary: Got question: " + question)
  // console.log("@ GuaSummary: Got numStr: " + numStr)

  function showYiOptions() {
    let x = document.getElementById("top-to-hide")
    x.style.display = "block"

    let y = document.getElementById("showgua")
    y.style.display = "none"

    // console.log("@ GuaSummary: guaName is " + guaName)

    // Reset view back to summary
    showView("")

    // Auto scroll back to the top of the page
    requestAnimationFrame(() => window.scrollTo(0, 0))
  }

  function showView(view) {
    showSummary = false
    showDetails = false

    // console.log("@ GuaSummary: showView option: " + view)

    if (view == "details") {
      showDetails = true
    } else {
      showSummary = true
    }
  }

  let upGua = ""
  let downGua = ""
  function getUpDownGuaName(guaName) {
    upGua = guaName[0]
    if (guaName[1] == "為") {
      downGua = upGua
    } else {
      downGua = guaName[1]
    }
  }

  $: getUpDownGuaName(guaName)
</script>

<!-- Gua Summary Section Begin -->
<div class="gua-summary" style="display:{showSummary ? 'block' : 'none'}">
  <div class="card indigo lighten-5">
    <div class="card-body gua-results">
      {#if $selectedLanguage == "TW"}
        <div class="gua-header">
          <h4>
            {guaName} 摘要

            <div class="btn-group right">
              {#if sectionName == "Books" && !isLogin}
                <button disabled class={btn_style_teal}>細究</button>
              {:else}
                <button
                  class={btn_style_teal}
                  on:click={() => showView("details")}>細究</button
                >
                {#if sectionName == "AutoQi"}
                  <a href="/records" class={btn_style_light_blue_a3}
                    >到卦例去紀錄心得</a
                  >
                {/if}
              {/if}
              {#if sectionName != "AutoQi" && sectionName != "HandQi"}
                <button class={btn_style_orange_d2} on:click={showYiOptions}
                  >回易經選項</button
                >
              {/if}
            </div>
          </h4>

          {#if sectionName == "AutoQi" || sectionName == "HandQi"}
            <div class="gua-question">
              <h5>問：{question}</h5>
              <!-- <h5>問：{AesCtr.decrypt(question, xiyiSalt, 256)}</h5> -->
            </div>
          {/if}
        </div>
      {:else}
        <div class="gua-header">
          <h4>
            {guaName} 摘要

            <div class="btn-group right">
              {#if sectionName == "Books" && !isLogin}
                <button disabled class={btn_style_teal}>细究</button>
              {:else}
                <button
                  class={btn_style_teal}
                  on:click={() => showView("details")}>细究</button
                >
                {#if sectionName == "AutoQi"}
                  <a href="/records" class={btn_style_light_blue_a3}
                    >到卦例去纪录心得</a
                  >
                {/if}
              {/if}
              {#if sectionName != "AutoQi" && sectionName != "HandQi"}
                <button class={btn_style_orange_d2} on:click={showYiOptions}
                  >回易经选项</button
                >
              {/if}
            </div>
          </h4>

          {#if sectionName == "AutoQi" || sectionName == "HandQi"}
            <div class="gua-question">
              <h5>问：{question}</h5>
              <!-- <h5>问：{AesCtr.decrypt(question, xiyiSalt, 256)}</h5> -->
            </div>
          {/if}
        </div>
      {/if}
      <!-- <hr /> -->
      <div class="gua-info">
        <div class="gua-level">
          <div class="gua-pic "><ShowGuaPic {numStr} {gua_code} /></div>
          <div class="gua-text green lighten-5">
            <ShowGuaText {numStr} {gua_code} />
          </div>
        </div>
        <div class="yao-level blue lighten-4">
          <ShowYaoText {numStr} {gua_code} />
        </div>
      </div>
      <!-- <hr /> -->
      <div class="gua-result-compoenet">
        {#if $selectedLanguage == "TW"}
          <h5>可能變動的爻和各相關卦簡表</h5>
        {:else}
          <h5>可能变动的爻和各相关卦简表</h5>
        {/if}
        {#if isLogin}
          <GuaResult {numStr} />
        {:else}
          <div class="member-only grey-text center">
            <h5>會員內容</h5>
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

<!-- Gua Summary Section End -->

<!-- Gua Detail Research Section Begin -->
<div class="details " style="display:{showDetails ? 'block' : 'none'}">
  <div class="card indigo lighten-5">
    <div class="card-body ">
      <div class="gua-header">
        <h4>
          {guaName} 細究
          <div class="btn-group right">
            <button
              class={btn_style_blue_d2 + " left"}
              on:click={() => showView("")}>摘要</button
            >

            {#if sectionName != "AutoQi" && sectionName != "HandQi"}
              <button
                class={btn_style_orange_d2 + " right"}
                on:click={showYiOptions}>回易經選項</button
              >
            {/if}
          </div>
        </h4>
        {#if sectionName == "qi"}
          <h5>問：{question}</h5>
        {/if}
      </div>
      <div class="gua-text green lighten-5">
        <ShowGuaText {numStr} {gua_code} />
      </div>
      <div class="yao-level ">
        <!--  -->
        <ShowCompleteYaoInfo
          {numStr}
          {gua_code}
          {sectionName}
          incomingYaoColor={yaoColor}
        />
      </div>
    </div>
  </div>
</div>

<!-- Gua Detail Research Section End -->
<style>
  .gua-level {
    display: grid;
    grid-template-columns: 1fr 4fr;
    min-height: 100px;
    margin-top: 15px;
    border-top: outset #7986cb 3px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .yao-level {
    width: 100%;
    min-height: 200px;
    border-top: outset #7986cb 3px;
    border-bottom: outset #7986cb 3px;
  }
  .gua-pic {
    margin: auto;
    /* justify-content: center; */
  }
  .gua-header h4 {
    padding-top: 20px;
    padding-bottom: 10px;
    margin-left: 10px;
    height: 80px;
    /* min-height: 50px; */
  }

  /* .btn-group {
    margin-top: 5px;
  } */
  .btn-single {
    margin-right: 10px;
    /* margin-left: 20px; */
  }
  .d-detail-view {
    display: grid;
    grid-template-columns: 1fr;
  }
  .gua-section {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 2fr 7fr;
  }
  .yao-t {
    display: grid;
    grid-template-columns: 1fr;
  }
  .member-only {
    height: 100px;
  }
  .gua-result-compoenet {
    padding-left: 15px;
    padding-bottom: 15px;
  }
</style>
